import { FUNDS_TRANSFER_BANNER_CONFIG } from "../config/fundsTransferBanners";
import { useLocationStateBanner } from "../../../hooks/useLocationStateBanner";

export function useFundsTransferBanner() {
  return useLocationStateBanner({
    config: FUNDS_TRANSFER_BANNER_CONFIG,
    stateKey: "fundsTransferBannerReason",
  });
}
